export default "__VITE_ASSET__e36852b0__"